module.exports = __webpack_public_path__ + "media/cover_1600.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/media/cover_1600.jpg
// module id = 18
// module chunks = 0